import React from "react";
import BDLogo from "@/components/BDLogo";
import { footerLinks, footerBadges, brand } from "@/mock";
import * as Icons from "lucide-react";
import { Facebook, Instagram, Youtube, Music2 } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white">
      {/* badges */}
      <div className="border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-8 grid grid-cols-1 md:grid-cols-4 gap-6 items-center">
          {footerBadges.map((b) => {
            const Icon = Icons[b.icon] || Icons.Check;
            return (
              <div key={b.title} className="flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-white/[0.06] border border-white/10 flex items-center justify-center shrink-0">
                  <Icon size={20} className="text-[#ff2626]" strokeWidth={2.2} />
                </div>
                <div>
                  <div className="text-[12px] font-black tracking-[0.14em] uppercase">{b.title}</div>
                  <div className="text-[12px] text-white/50">{b.sub}</div>
                </div>
              </div>
            );
          })}
          <div className="flex items-center justify-start md:justify-end gap-4">
            <div className="text-[12px] font-black tracking-[0.14em] uppercase text-white/70">
              Follow the club
            </div>
            <div className="flex items-center gap-3">
              {[Instagram, Facebook, Music2, Youtube].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  className="h-9 w-9 rounded-full bg-white/[0.06] border border-white/10 flex items-center justify-center hover:bg-[#c60d0d] hover:border-[#c60d0d] transition"
                >
                  <I size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* links */}
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 bg-black rounded-sm overflow-hidden">
              <img
                src={require("@/components/BDLogo").LOGO_URL}
                alt="BD"
                className="w-full h-full object-cover object-top scale-[1.8] translate-y-1"
              />
            </div>
            <div>
              <div className="font-black text-[17px] leading-none">BIG DICK&rsquo;S</div>
              <div className="text-[9px] tracking-[0.3em] text-white/60 mt-1">UNDERGEAR</div>
            </div>
          </div>
          <p className="mt-5 text-white/60 text-[13px] leading-relaxed max-w-xs">
            {brand.tagline}. Premium undergear built for the men who know what fits.
          </p>
        </div>

        {Object.entries(footerLinks).map(([title, items]) => (
          <div key={title}>
            <div className="text-[12px] font-black tracking-[0.18em] uppercase mb-4">{title}</div>
            <ul className="space-y-2.5">
              {items.map((it) => (
                <li key={it}>
                  <a
                    href="#"
                    className="text-[13px] text-white/60 hover:text-[#ff2626] transition-colors"
                  >
                    {it}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] tracking-[0.14em] uppercase text-white/40">
          <div>© {new Date().getFullYear()} Big Dick&rsquo;s Undergear. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
